import { BillingEventData } from '@/common/types/billing/event.type'
import { formatCardNumber, formatCurrency, formatDateTime, formatDecimal, formatUnit } from '@/common/utils/formatters'
import EstablishmentEventAuthor from '@/features/establishments/components/EstablishmentEventAuthor'
import CompanyEventTotalFee from '@/features/privateCompanies/components/companyConsumptionTotalFee'
import {
  eventableDetailsComponent,
  eventableTypeTranslations,
} from '@/features/privateCompanies/services/companyBillingEventTransformer'
import { UserEventData } from '@/features/privateCompanies/types/userEvents.type'
import { createElement } from 'react'

export class UserEventsTransformer {
  static tableTransformer() {
    return (userEvents: UserEventData[]) => {
      return userEvents.map((userEvent) => ({
        protocol_number: userEvent.protocol_number ? `${userEvent.protocol_number}` : '',
        bill: 'Não implementado',
        type: userEvent.eventable_type ? eventableTypeTranslations[userEvent.eventable_type] : '',
        details: eventableDetailsComponent[userEvent.eventable_type]
          ? createElement(eventableDetailsComponent[userEvent.eventable_type], { data: userEvent.eventable })
          : '',
        total_amount: userEvent.eventable?.total_amount
          ? formatCurrency(userEvent.eventable?.total_amount)
          : '',
        fee_total: userEvent.fee_total
          ? createElement(CompanyEventTotalFee, { data: userEvent as unknown as BillingEventData })
          : '',
        company: userEvent.eventable?.client_branch?.general_information?.fantasy_name || '',
        card: userEvent.eventable.card.last_four_digits
          ? formatCardNumber(userEvent.eventable.card.last_four_digits)
          : '',
        current_equipment_usage: userEvent.eventable?.current_equipment_usage
          ? formatUnit(formatDecimal(userEvent.eventable?.current_equipment_usage, 0), 'kilometers')
          : '',
        author: userEvent.author
        ? createElement(EstablishmentEventAuthor, { data: userEvent.author })
        : '',
        created_at: userEvent.created_at ? formatDateTime(new Date(userEvent.created_at)) : '',
      }))
    }
  }
}
